import { useLang } from "../../i18n/LanguageContext";

const clients_en = ["VISIONARY LABS", "AL-NOOR CAPITAL", "GULF HEALTH", "CEDAR REAL ESTATE", "ARABIA EDU", "HORIZON LOGISTICS", "OASIS HOSPITALITY", "BLUE FIN TECH"];

export const ClientsMarquee = () => {
  const { lang } = useLang();
  return (
    <section className="relative py-14 border-y border-hair" data-testid="clients-marquee">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <div className="text-[11px] mono-label text-soft text-center mb-6">
          {lang === "en"
            ? "WORKING WITH AMBITIOUS TEAMS ACROSS THE GULF"
            : "نعمل مع فرق طموحة في الخليج"}
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-16 animate-marquee whitespace-nowrap">
          {[...clients_en, ...clients_en, ...clients_en].map((n, i) => (
            <span key={i} className="text-2xl md:text-3xl font-semibold tracking-tight text-mid hover:text-cyan-300 transition">
              {n}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsMarquee;
